/**
 * Removes duplicate numbers from an array.
 * @param numbers - The array of numbers.
 * @returns An array with duplicate numbers removed.
 */
const removeDuplicateNumbers = (numbers: number[]): number[] =>
  Array.from(new Set(numbers))

export default removeDuplicateNumbers
